/*
 * Product Variant Select Listener - trigger alternative products
 *
 **/

custom.pdpVariantSelect = (() => {
  const selectorClassName = 'js-variant-select';

  /*
   * updateVisibleWallArt
   * Update what data is visible based on the currently selected variant.
   */
  function updateVisibleWallArt(val) {
    if (val) {
      $('.wall-art-variant').each(function () {
        if ($(this).data('variant-id') && $(this).data('variant-id') == val) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });
    }
  }

  function onChangeHandler(event = {}, item = {}) {
    const option = $(event.currentTarget).find('option:selected');
    item.price = $(option).data('original-price'); // Overwrite with selected price

    if (
      event.currentTarget &&
      $(event.currentTarget).data('type') == 'WALL ART'
    ) {
      //console.log($(event.currentTarget));
      updateVisibleWallArt($(event.currentTarget).val());
    }
  }

  function init(item = {}) {
    $(`.${selectorClassName}`).on('change', (e) => {
      onChangeHandler(e, item);
    });
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-variant-select.js